<template>
    <Carousel :value="data" :numVisible="numVisible" :numScroll="numScroll" :orientation="orientation" :responsiveOptions="responsiveOptions" verticalViewPortHeight="330px" contentClass="flex align-items-center">
        <template #item="slotProps">
            <div class="border-1 surface-border border-round m-2  p-3">
                <div class="mb-3">
                    <div class="relative mx-auto">
                        <img :src="slotProps.data.image" :alt="slotProps.data.name" class="w-full border-round" />
                        <Tag :value="slotProps.data.inventoryStatus" :severity="getSeverity(slotProps.data.inventoryStatus)" class="absolute" style="left:5px; top: 5px"/>
                    </div>
                </div>
                <div class="mb-3 font-medium">{{ slotProps.data.name }}</div>
                <div class="flex justify-content-between align-items-center">
                    <div class="mt-0 font-semibold text-xl">${{ slotProps.data.price }}</div>
                    <span>
                        <button class="bg-light"><i class="fas fa-heart"></i></button>
                        <button><i class="fas fa-shopping-cart"></i></button>
                    </span>
                </div>
            </div>
        </template>
    </Carousel>


</template>


<script>
import Carousel from 'primevue/carousel';

export default {
    name: "CarouselVueC",
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        orientation: {
            type: String,
            default: ""
        },
        numVisible: {
            type: Number,
            default: 1
        },
        numScroll: {
            type: Number,
            default: 1
        },
    },
    components: {
        Carousel,
    },
    setup() {

        const responsiveOptions = ref([
            {
                breakpoint: '1400px',
                numVisible: 2,
                numScroll: 1
            },
            {
                breakpoint: '1199px',
                numVisible: 3,
                numScroll: 1
            },
            {
                breakpoint: '767px',
                numVisible: 2,
                numScroll: 1
            },
            {
                breakpoint: '575px',
                numVisible: 1,
                numScroll: 1
            }
        ]);

        return {
            responsiveOptions,
        };
    },
}
</script>